import { ThemeProvider, Typography, withStyles } from "@material-ui/core";

import React from "react";
import { theme } from "../constants/theme";
import tradeKartIcon from "../assets/icons/tradeKartIcon.svg";
type Props = {
  data: any;
  ref: any;
  classes: any;
};
class PrintableItemList extends React.PureComponent<Props> {
  render() {
    const { classes, data } = this.props;

    return (
      <div className="container" style={{ margin: "0", padding: "0" }}>
        <div className={classes.container}>
          <ThemeProvider theme={theme}>
            <div className={classes.innerContainer}>
              <div className={classes.header}>
                <img
                  src={tradeKartIcon}
                  className={classes.tradeKartIcon}
                  alt="TradeKart icon"
                />
                <Typography variant="h6" component="p">
                  TradeKart
                </Typography>
              </div>
              <div className={classes.title} style={{ flexDirection: "row" }}>
                <Typography variant="body1" component="p">
                  Item list
                </Typography>

                <Typography variant="body2" component="p">
                  {"Order no: " + data.OrderNo}
                </Typography>
              </div>
              {data.Orderlines.map((item: any, index: any) => {
                const isUpdated =
                  item.OrderLineOriginalQuantity > item.OrderLineQuantity;
                return (
                  <div
                    key={index}
                    className={classes.gridContainer}
                    style={{
                      position: "relative",
                    }}
                  >
                    <div
                      className={classes.col}
                      style={{ flexDirection: "column" }}
                    >
                      <img
                        src={
                          item.VariantImageUrl || item.OrderLineProductImageUrl
                        }
                        width="50px"
                        alt="item variant"
                      />
                    </div>
                    <div
                      className={`${classes.col} ${
                        item.OrderLineQuantity === 0
                          ? classes.rejectedDecoration
                          : ""
                      }`}
                      style={{
                        paddingLeft: "10mm",
                        flexDirection: "column",
                        textDecoration:
                          item.OrderlineCancelled !== null ||
                          item.OrderLineQuantity === 0
                            ? "line-through"
                            : "none",
                        textDecorationColor:
                          item.OrderLineQuantity === 0 ? "#E54C35" : "",
                      }}
                    >
                      <Typography
                        variant="body2"
                        align="center"
                        component="p"
                        style={{ fontWeight: 800 }}
                      >
                        Item name
                      </Typography>
                      <Typography variant="body1" align="center" component="p">
                        {item.ProductTitle +
                          "  " +
                          (item.OrderLineVariantTitle === "Default Title"
                            ? ""
                            : item.OrderLineVariantTitle)}
                      </Typography>
                    </div>
                    {this.getItemOptions(item.Options, item)}
                    <div
                      className={classes.col}
                      style={{
                        flexDirection: "column",
                        textDecoration:
                          item.OrderlineCancelled !== null ||
                          item.OrderLineQuantity === 0
                            ? "line-through"
                            : "none",
                        textDecorationColor:
                          item.OrderLineQuantity === 0 ? "#E54C35" : "",
                      }}
                    >
                      <Typography
                        variant="body2"
                        component="p"
                        style={{ fontWeight: 800 }}
                      >
                        SKU
                      </Typography>
                      <Typography variant="body1" component="p">
                        {item.OrderLineVariantSKU}
                      </Typography>
                    </div>
                    <div
                      className={classes.col}
                      style={{
                        flexDirection: "column",
                        textDecoration:
                          item.OrderlineCancelled !== null ||
                          item.OrderLineQuantity === 0
                            ? "line-through"
                            : "none",
                        textDecorationColor:
                          item.OrderLineQuantity === 0 ? "#E54C35" : "",
                      }}
                    >
                      <Typography
                        variant="body2"
                        component="p"
                        style={{ fontWeight: 800 }}
                      >
                        Quantity
                      </Typography>
                      <Typography variant="body1" component="p">
                        {`${item.OrderLineQuantity} ${
                          isUpdated ? "(Updated)" : ""
                        }`}
                      </Typography>
                    </div>

                    {item.OrderlineCancelled !== null ? (
                      <div
                        className={classes.col}
                        style={{
                          flexDirection: "column",
                          textDecoration: "unset",
                        }}
                      >
                        <Typography
                          variant="body1"
                          component="p"
                          style={{ fontWeight: 1000, textDecoration: "unset" }}
                        >
                          Cancelled
                        </Typography>
                      </div>
                    ) : (
                      <></>
                    )}
                    {item.OrderLineQuantity === 0 ? (
                      <div
                        className={classes.col}
                        style={{
                          flexDirection: "column",
                          textDecoration: "unset",
                        }}
                      >
                        <Typography
                          variant="body1"
                          component="p"
                          style={{
                            fontWeight: 1000,
                            textDecoration: "unset",
                            color: "#E54C35",
                          }}
                        >
                          Rejected
                        </Typography>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                );
              })}
            </div>
          </ThemeProvider>
        </div>
      </div>
    );
  }
  getItemOptions = (options: any, item: any) => {
    const response: any[] = [];
    if (item.ColorNote !== "" && item.ColorNote !== null) {
      response.push(
        <div
          className={this.props.classes.col}
          style={{
            flexDirection: "column",
            textDecoration:
              item.OrderlineCancelled !== null || item.OrderLineQuantity === 0
                ? "line-through"
                : "none",
            textDecorationColor: item.OrderLineQuantity === 0 ? "#E54C35" : "",
          }}
        >
          <Typography
            variant="body1"
            style={{ textDecorationLine: "underline", fontWeight: 800 }}
            component="p"
          >
            {"Colour note"}
          </Typography>
          <Typography variant="body2" align="center" component="p">
            {item.ColorNote}
          </Typography>
        </div>
      );
    }

    options.map((optionItem: any, index: any) => {
      if (optionItem.Name === "Title" || optionItem === "") {
        return <></>;
      } else {
        response.push(
          <div
            key={index}
            className={this.props.classes.col}
            style={{
              flexDirection: "column",
              textDecoration:
                item.OrderlineCancelled !== null || item.OrderLineQuantity === 0
                  ? "line-through"
                  : "none",
              textDecorationColor:
                item.OrderLineQuantity === 0 ? "#E54C35" : "",
            }}
          >
            <Typography
              variant="body2"
              style={{ textDecorationLine: "underline", fontWeight: 800 }}
              component="p"
            >
              {optionItem.Name}
            </Typography>
            <Typography variant="body1" component="p">
              {optionItem.Value}
            </Typography>
          </div>
        );
      }
      return null;
    });

    return response;
  };
}

const styles = (theme) => ({
  container: {
    height: "100vh",
    padding: "2mm",
    border: "1px solid black",
  },
  innerContainer: {
    border: "1px solid black",
    height: "100%",
    borderRadius: "10px",
  },
  header: {
    paddingLeft: "5mm",
    paddingTop: "5mm",
    display: "flex",
    alignItems: "center",
  },
  orderNoContainer: {},
  tradeKartIcon: {
    width: "8mm",
    height: "8mm",
    borderRadius: "1px",
    marginRight: "1mm",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "auto 1fr 1fr 1fr 1fr",

    borderBottom: "1px solid #000000",
    paddingLeft: "3mm",
    paddingTop: "3mm",
    paddingBottom: "3mm",
  },
  col: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  colQuantitiy: {
    display: "flex",

    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    marginTop: "10mm",
    marginBottom: "3mm",
    paddingLeft: "5mm",
    paddingRight: "5mm",
    borderBottom: "2px solid #000000",
    justifyContent: "center",
    alignContent: "space-between",
  },
  cancelled: {},
});
export default withStyles(styles)(PrintableItemList);
